/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import getCep from '../../services/getCep';
import CPFInput from '../atoms/CPFInput';

const Row = styled.div`
  display: flex;
  margin: 2px 0;
  flex-direction: column;
`;

const RowGroup = styled.div`
  display: grid;
  justify-content: space-between;
  grid-template-columns: 1fr 60px;
  ${Row}:first-child {
    margin-right: 10px;
  }
`;

const Input = ({ label, value, type = 'text', placeholder, onChange }) => (
  <Row>
    <label>{label}</label>
    <input type={type} value={value} placeholder={placeholder} onChange={onChange} />
  </Row>
);

const NewAddress = ({ data, onNewAddress }) => {
  const [address, setAddress] = useState();
  const [number, setNumber] = useState();
  const [district, setDistrict] = useState();
  const [city, setCity] = useState();
  const [state, setState] = useState();
  const [zip, setZip] = useState();
  const [complement, setComplement] = useState();

  const fetchAddressByCEP = (cepCode) =>
    getCep(cepCode).then((result) => {
      setState(result.uf);
      setCity(result.city);
      setDistrict(result.neighborhood);
      setAddress(result.street);
    });

  useEffect(() => {
    if (!data) return;
    setAddress(data.address);
    setNumber(data.number);
    setDistrict(data.district);
    setCity(data.city);
    setState(data.state);
    setZip(data.zip);
    setComplement(data.complement);
  }, [data]);

  const callNewAddress = useCallback(() => {
    if (onNewAddress) {
      onNewAddress({
        address,
        number,
        district,
        city,
        state,
        zip,
        complement
      });
    }
  }, [address, onNewAddress, number, district, city, state, zip, complement]);

  useEffect(() => {
    callNewAddress();
  }, [callNewAddress]);

  return (
    <>
      <RowGroup>
        <Row>
          <label>CEP</label>
          <CPFInput
            value={zip}
            onBlur={(e) => fetchAddressByCEP(e.target.value)}
            onChange={(e) => setZip(e.target.value)}
          />
        </Row>
        <Input
          label="Número"
          placeholder="Número da casa, prédio, etc."
          value={number}
          onChange={(e) => setNumber(e.target.value)}
        />
      </RowGroup>
      <RowGroup>
        <Input label="Cidade" placeholder="Nome da Cidade" value={city} />
        <Input label="Estado" placeholder="Nome do Estado" value={state} />
      </RowGroup>
      <Input label="Bairro" placeholder="Bairro ou localidade" value={district} />
      <Input label="Endereço" placeholder="Rua, avenida, etc" value={address} />
      <Input
        label="Complemento"
        placeholder="Complemento do endereço, se houver"
        value={complement}
        onChange={(e) => setComplement(e.target.value)}
      />
    </>
  );
};

export default NewAddress;
